import { Send } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Input } from '@kainos/ui';

export interface ChatComposerProps {
  onSubmit: (question: string) => void;
  disabled?: boolean;
}

/** Text field plus send button at the bottom of the drawer. */
export function ChatComposer({ onSubmit, disabled }: ChatComposerProps) {
  const [value, setValue] = useState('');

  const submit = (event: FormEvent) => {
    event.preventDefault();
    const question = value.trim();
    if (!question || disabled) return;
    onSubmit(question);
    setValue('');
  };

  return (
    <form onSubmit={submit} className="flex gap-2">
      <Input
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder="Escribe tu pregunta…"
        aria-label="Pregunta para KainOS AI"
        disabled={disabled}
      />
      <button
        type="submit"
        disabled={disabled || value.trim().length === 0}
        aria-label="Enviar pregunta"
        className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-[9px] bg-primary text-white transition-colors hover:bg-[#1D4ED8] disabled:opacity-50"
      >
        <Send size={16} strokeWidth={1.8} />
      </button>
    </form>
  );
}
